
import PaginationCommon from '../../components/element-ui/Pagination'
import { INDEX_SET_LOADING, GET_LIST_COLLECTION } from '../../store/store.const'

export default {
  name: 'CollectionPage',
  components: {
    PaginationCommon
  },
  data() {
    return {
      collection: [],
      total: 0,
      page: 1,
      last_page: 1,
      per_page: 10,
      fullscreenLoading: false
    }
  },
  head() {
    const tags = {}
    tags.title = this.$t('seo.collection.title')
    tags.meta = [
      { hid: 'title', name: 'title', content: this.$t('seo.collection.title') },
      { hid: 'description', name: 'description', content: this.$t('seo.collection.description') },
      { hid: 'keywords', name: 'keywords', content: this.$t('seo.collection.keywords') },
      { hid: 'twitter:card', name: 'twitter:card', content: 'summary' },
      { hid: 'twitter:title', name: 'twitter:title', content: this.$t('seo.collection.title') },
      { hid: 'twitter:description', name: 'twitter:description', content: this.$t('seo.collection.description') },
      { hid: 'twitter:keywords', name: 'twitter:keywords', content: this.$t('seo.collection.keywords') },
      { hid: 'og:type', property: 'og:type', content: 'website' },
      { hid: 'og:title', property: 'og:title', content: this.$t('seo.collection.title') },
      { hid: 'og:description', property: 'og:description', content: this.$t('seo.collection.description') },
      { hid: 'og:keywords', property: 'og:keywords', content: this.$t('seo.collection.keywords') }
    ]
    return tags
  },
  async created() {
    await this.getListCollection()
  },
  methods: {
    handleClickCollection(id) {
      this.$router.push('/collection/' + id)
    },
    async getListCollection() {
      try {
        await this.$store.commit(INDEX_SET_LOADING, true)
        const search = {
          page: this.page,
          per_page: this.per_page,
          'orders[0][key]': 'created_at',
          'orders[0][dir]': 'desc'
        }
        const collection = await this.$store.dispatch(GET_LIST_COLLECTION, { filters: search })
        if (!this.$device.isMobile) {
          this.collection = collection.data.data
          this.page = collection.data.current_page
          this.last_page = collection.data.total_page
          this.total = collection.data.total
        } else {
          this.collection = collection.data.data
          this.page = collection.data.current_page
          this.last_page = collection.data.total_page
          this.total = collection.data.total
        }
      } catch (error) {
        console.log(error)
      }
      await this.$store.commit(INDEX_SET_LOADING, false)
    },
    async changePaginate(page) {
      this.page = page
      await this.getListCollection()
    },
    handleImageError(item) {
      item.image = null
    }
  }
}
